import { MAX_DOCUMENT_EXPIRY_DATE } from "~/utils/constants";
import CertifiedFieldFormValue from "../ReusableFormValues/CertifiedFieldFormValue";
import DateFieldFormValue from "../ReusableFormValues/DateFieldFormValue";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { idDocumentTypesArray } from "./constants";

export type Props = {
  readonly: boolean;
  documentName?: string;
};

const IdDocFormValues = ({ readonly, documentName = "" }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={idDocumentTypesArray}
        placeholder="Select an ID document type"
        name="secondaryDocumentType"
        label="Document sub-type"
        documentName={documentName}
      />
      <DateFieldFormValue
        name="expiryDate"
        label="Expiry Date"
        readonly={readonly}
        maxDate={MAX_DOCUMENT_EXPIRY_DATE}
        showExpiredWarning
      />
      <CertifiedFieldFormValue readonly={readonly} />
    </>
  );
};

export default IdDocFormValues;
